export class ShortDataLesson {
    constructor(
        public id: number,
        public date: string,
        public epoch: number,
        public status: number,
        public lesson_number: number,
        public title: string = null,
        public payment_for_task_with_cash: boolean,
        public reward_with_cash: boolean,
        public class_title: string,
        public class_id: number,
        public subject: string,
        public remarks: string = null
    ) {}
}
